import { Controller } from "@hotwired/stimulus"

// Pàgines sense enllaç propi al menú: marquen l'enllaç pare segons un
// paràmetre de context de la query string
const CONTEXTUAL_PARAM_FALLBACKS = [
  {
    match: (params) => params.has("producer_id"),
    target: "/producers",
  },
  {
    match: (params) => params.has("producer_association_id"),
    target: "/elaborators/producer_associations_index",
  },
  {
    match: (params) => params.has("elaborator_id") && params.has("from_association"),
    target: "/elaborators/producer_associations_index",
  },
  {
    match: (params) => params.has("elaborator_id"),
    target: "/elaborators",
  },
  {
    match: (params) => params.has("technician_id"),
    target: "/technicians",
  },
];

// Controlador que gestiona l'estat actiu dels elements del menú lateral
export default class extends Controller {
  connect() {
    this.setActiveLink();
  }

  // Estableix l'element actiu del menú basant-se en la ruta actual
  setActiveLink() {
    const pathname = window.location.pathname;
    const effectivePathname = this.resolvePathname(pathname);
    const activeLink = this.findActiveLink(effectivePathname);
    const sidebarItems = document.querySelectorAll(
      'li.sidebar-item a.sidebar-link[data-bs-toggle="collapse"] + ul.sidebar-dropdown'
    );
  
    // Netegem l'estat actiu de tots els elements
    document.querySelectorAll(".sidebar-item.active")?.forEach((item) => {
      item.classList.remove("active");
    });
  
    document.querySelectorAll(".sidebar-dropdown.active")?.forEach((dropdown) => {
      dropdown.classList.remove("active");
    });
  
    if (pathname === "/") return;
  
    // Marquem el desplegable que conté l'enllaç actiu
    if (activeLink && sidebarItems.length > 0) {
      for (let i = 0; i < sidebarItems.length; i++) {
        const sidebarItem = sidebarItems[i];

        if (sidebarItem.contains(activeLink)) {
          const parentElement = sidebarItem.parentElement;
          if (parentElement) {
            parentElement.classList.add("active");
          }

          const links = document.querySelectorAll(".sidebar-link");
          links?.forEach((link) => {
            const item = link.closest(".sidebar-item");

            if (item && item !== parentElement) {
              const dropdown = item.querySelector(".sidebar-dropdown");

              item.classList.remove("active");
              if (dropdown) {
                dropdown.classList.remove("active");
              }
            }
          });

          break;
        }
      }
    }

    // Processem els enllaços directes
    if (activeLink) {
      const activeItem = activeLink.closest(".sidebar-item");
      if (activeItem) {
        activeItem.classList.add("active");
  
        if (activeItem.classList.contains("unique")) {
          const links = document.querySelectorAll(".sidebar-link");
  
          links?.forEach((link) => {
            const item = link.closest(".sidebar-item");
            if (item && item !== activeItem) {
              const dropdown = item.querySelector(".sidebar-dropdown");
  
              item.classList.remove("active");
              if (dropdown) {
                dropdown.classList.remove("active");
              }
            }
          });
        }
      }
    }
  }

  // Retorna la mateixa ruta si té enllaç al menú; si no, l'enllaç pare
  resolvePathname(pathname) {
    if (this.findActiveLink(pathname)) return pathname;

    const params = new URLSearchParams(window.location.search);

    for (const fallback of CONTEXTUAL_PARAM_FALLBACKS) {
      if (fallback.match(params)) return fallback.target;
    }

    return pathname;
  }

  // Troba l'enllaç actiu que coincideix amb la ruta (exacta o prefix)
  findActiveLink(pathname) {
    const allLinks = document.querySelectorAll(".sidebar-link");
    let matchedLink = null;

    allLinks.forEach((link) => {
      const href = link.getAttribute("href");
      if (!href) return;

      // exact-match: només coincidència exacta
      if (link.classList.contains("exact-match")) {
        if (href === pathname) {
          matchedLink = link;
        }
      } else if (href === pathname) {
        matchedLink = link;
      } else if (pathname.startsWith(href + "/")) {
        // Coincidència de prefix: ens quedem la més específica (més llarga)
        if (!matchedLink || matchedLink.getAttribute("href").length < href.length) {
          matchedLink = link;
        }
      }
    });

    return matchedLink;
  }
}